<ng-container *ngIf="showButton">
  <!--NOTE: Switch button types by route type-->
  <div [ngSwitch]="routeType">
    <!--DISABLED ROUTE TYPE-->
    <!--NOTE: Disabled routes is used for disabled state button-->
    <ng-container *ngSwitchCase="'disabled'">
      <button [id]="id" [attr.data-beyond-button-id]="id" [disabled]="true" class="btn btn-primary">
        {{ actionLabel }}
      </button>
    </ng-container>
    <!--END DISABLED ROUTE TYPE-->
    <!--INTERNAL ROUTE TYPE-->
    <!--NOTE: Internal routes uses angular internal routing for redirects and app navigations-->
    <ng-container *ngSwitchCase="routeTypes.INTERNAL">
      <div [ngClass]="actionButtonCss ? actionButtonCss : ''">
        <button
          [id]="id"
          [attr.data-beyond-button-id]="id"
          (click)="onClick()"
          class="btn"
          [ngClass]="customButtonCss ? customButtonCss : ''">
          {{ actionLabel }}
        </button>
      </div>
    </ng-container>
    <!--END INTERNAL ROUTE TYPE-->
    <!--SECONDARY INTERNAL ROUTE TYPE-->
    <!--NOTE: Internal secondary internal routes uses angular internal routing for redirects and app navigations-->
    <ng-container *ngSwitchCase="routeTypes.SUBSCRIPTION">
      <div [ngClass]="actionButtonCss ? actionButtonCss : ''">
        <button
          [id]="id"
          [attr.data-beyond-button-id]="id"
          (click)="onClick()"
          class="btn"
          [ngClass]="customButtonCss ? customButtonCss : ''">
          {{ actionLabel }}
        </button>
      </div>
    </ng-container>
    <!--END SECONDARY INTERNAL ROUTE TYPE-->
    <!--MODAL ROUTE TYPE-->
    <!--NOTE: Modal ignores route and buttonRoute and depends on separate send click event-->
    <ng-container *ngSwitchCase="routeTypes.MODAL">
      <div [ngClass]="actionButtonCss ? actionButtonCss : ''">
        <button
          [id]="id"
          [attr.data-beyond-button-id]="id"
          (click)="onClick()"
          class="btn"
          [ngClass]="customButtonCss ? customButtonCss : ''">
          {{ actionLabel }}
        </button>
      </div>
    </ng-container>
    <!--END MODAL ROUTE TYPE-->
    <!--MAILTO ROUTE TYPE-->
    <!--NOTE: Mailto creates a link and sends a mailto inside a href attribute on separate send click event-->
    <ng-container *ngSwitchCase="routeTypes.MAILTO">
      <a
        [id]="id"
        [attr.data-beyond-button-id]="id"
        href="{{ mailToDetails }}"
        (click)="onClick()"
        class="btn"
        [ngClass]="customButtonCss ? customButtonCss : ''">
        {{ actionLabel }}
      </a>
    </ng-container>
    <!--END MAILTO ROUTE TYPE-->
    <!--EXTERNAL URL ROUTE TYPE-->
    <!--NOTE: External urls call outside of angular routing, example external docebo urls-->
    <ng-container *ngSwitchCase="routeTypes.EXTERNAL">
      <div [ngClass]="actionButtonCss ? actionButtonCss : ''">
        <a
          [id]="id"
          [attr.data-beyond-button-id]="id"
          class="btn"
          [ngClass]="customButtonCss ? customButtonCss : ''"
          target="_blank"
          rel="noopener noreferrer nofollow"
          (click)="onClick()"
          href="{{ buttonRoute }}">
          {{ actionLabel }}
        </a>
        &nbsp;
        <a
          *ngIf="showSecondaryButton"
          [id]="id"
          [attr.data-beyond-button-id]="id"
          class="btn btn-inverse"
          (click)="onSecondaryClick()">
          {{ secondaryActionLabel }}
        </a>
      </div>
    </ng-container>
    <!--EXTERNAL URL ROUTE TYPE-->
    <!--LOGIN ROUTE TYPE-->
    <ng-container *ngSwitchCase="routeTypes.LOGIN">
      <a
        [id]="id"
        [attr.data-beyond-button-id]="id"
        class="btn"
        routerLink="/login"
        [ngClass]="customButtonCss ? customButtonCss : ''"
        rel="noopener noreferrer nofollow"
        href="javascript:void(0)">
        {{ actionLabel }}
      </a>
    </ng-container>
    <!--END LOGIN ROUTE TYPE-->
  </div>
  <!--ERROR MESSAGE-->
  <ng-container *ngIf="showErrorMessage && errorMessage">
    <br />
    <div class="error-message">{{ errorMessage }}</div>
  </ng-container>
  <!--ERROR MESSAGE-->
</ng-container>
